import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import {
  getAnalytics,
  provideAnalytics,
  ScreenTrackingService,
  UserTrackingService,
} from '@angular/fire/analytics';
import { GoogleMapsModule } from '@angular/google-maps';
import { environment } from '../../environments/environment';
import { importProvidersFrom } from '@angular/core';

const enableAnalytics = environment.env !== 'local';

const firebaseProviders: Array<EnvironmentProviders | any> = [
  provideFirebaseApp(() => initializeApp(environment.firebase)),
  ...(enableAnalytics ? [provideAnalytics(() => getAnalytics())] : []),
];

export const integrationsProviders = [
  makeEnvironmentProviders(firebaseProviders),
  importProvidersFrom(GoogleMapsModule),
  ...(enableAnalytics ? [ScreenTrackingService, UserTrackingService] : []),
];
